import { LucideLogOut } from 'lucide-react';
import { FC } from 'react';
import { getAuth } from 'firebase/auth';

export const Signout: FC = () => {
  return (
    <div
      className="flex flex-row gap-4 text-text-light rounded-lg px-4 py-3 md:py-2 cursor-pointer hover:bg-slate-50 active:bg-slate-100 transition-colors w-full touch-manipulation min-h-[44px] md:min-h-[36px]"
      onClick={async () => {
        await getAuth().signOut();
        document.cookie = 'session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        sessionStorage.clear();
      }}
    >
      <LucideLogOut className="w-5 h-5 flex-shrink-0" />
      <div className="truncate text-base md:text-sm">Sign out</div>
    </div>
  );
};
